module.exports = __webpack_public_path__ + "static/media/scr_launch_ios.b8c3ad56.png";